module.exports = __webpack_public_path__ + "static/media/logo.99efad41.png";